import * as Sentry from '@sentry/react-router';
import type { SeverityLevel } from '@sentry/react-router';

export function logSentry(
	label: string,
	extra: Record<string, unknown>,
	level: SeverityLevel = 'info'
) {
	Sentry.captureMessage(label, { level, extra });
}

export function logSentryError(err: unknown, extra: Record<string, unknown>) {
	Sentry.captureException(err, { extra });
}
